export default __webpack_public_path__ + "static/23_1-627b3636c92ab4e258387aaf59babfac.png";